module.exports = __webpack_public_path__ + "static/img/116.243b615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/116.png
// module id = EAtQ
// module chunks = 0